export const loading = (state = { loading: false }, action) => {
  if (action.type === "START_SUBMIT") {
    return { ...state, loading: true };
  }
  if (action.type === "END_SUBMIT") {
    return { ...state, loading: false };
  }

  return state;
};
